<template>
  <div class="postcode-search-component">
    <!-- <form action>
      <div class="row">
        <div class="col-lg-12">
          <label for="autocomplete">{{ find_local_dealership }}</label>
          <input type="text" id="autocomplete" ref="autocomplete"
           :placeholder="placeholder" @click.prevent="getData" @keydown.enter.prevent="getData"/>
        </div>
      </div>
    </form> -->

    <transition>
      <div>
        <select v-model="selectedData" class="store-list" :required="true" @mouseup="mouseUp" @input="selectedStore">
          <option :value="this.selectedData" disabled hidden>{{find_local_dealership}}</option>
          <option v-for="(store, index) in filteredStores.slice(0, 4)" :key="index"
                  :value="store.title"
          >{{store.title}}</option>
        </select>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import gmapsInit from "../utils/gmaps.js";

export default {
  name: "postcode-search",
  props: {
    sskey: {
      type: String,
      default: "dealerMode"
    },
    imperial_system: {
      type: String,
      default: "0"
    },
    latitude: {
      type: String
    },
    longitude: {
      type: String
    },
    formatted_address: {
      type: String
    },
    placeholder: {
      type: String,
      default: "Search by suburb or postcode"
    },
    search: {
      type: String,
      default: "Search"
    },
    distance: {
      type: String,
      default: "Distance"
    },
    form_field_id: {
      type: String,
    },
    customer_postcode: {
      type: String
    },
    customer_address: {
      type: String
    },
    location: {
      type: String,
      default: "Location"
    },
    find_local_dealership: {
      type: String,
      default: "Find Local Dealership"
    },
    stores_within: {
      type: String,
      default: "stores within"
    },
    label_select_dealer: {
      type: String,
      default: "Select Dealer",
    },
  },
  data() {
    return {
      baseUrl: "api/search/store/",
      radius: this.kmOrMiNumber(100),
      limit: 50,
      stores: [],
      serviceFilters: [],
      stockTypes: [],
      stockFilters: [],
      lat: null,
      lng: null,
      postcode: null,
      showFilters: true,
      filterIcon: "../images/temp/filter.svg",
      closeIcon: "../images/temp/close-2.svg",
      sessionStorageSet: false,
      countryCode: 'AU',
    };
  },
  async mounted() {

    var culture = window.culture;
      if(culture == 'en-nz'){
        this.countryCode = 'nz';
      }else if(culture == 'en-us' || culture == 'es-us'){
        this.countryCode = 'us';
      }else if(culture == 'en-ca' || culture == 'fr-ca' ){
        this.countryCode = 'ca';
      }else if(culture == 'en-de' || culture == 'de-de'){
        this.countryCode = 'de';
      }else{
        this.countryCode = 'au';
      }

    let len = sessionStorage.getItem(this.sskey)
      ? sessionStorage.getItem(this.sskey).length
      : 0;
    this.sessionStorageSet = len > 0 ? true : false;

    // create google
    window.google = await gmapsInit();
    if(this.customer_postcode != null && this.customer_postcode != ''){
      let location = await this.getLocationData(this.customer_postcode , this.countryCode);
      this.lng = location.geometry.location.lng();
      this.lat = location.geometry.location.lat();
    }

    if (this.formatted_address) {
      this.$refs.autocomplete.value = this.formatted_address;
    }

    if (this.lat && this.lng) {
      this.getData();
    }

    // const autocomplete = new window.google.maps.places.Autocomplete(
            
    //   this.$refs.autocomplete,
    //   {
    //     componentRestrictions: {
    //       country: window.culture.split("-")[1]
    //     },
    //     types: ["(regions)"],
        
    //   },
    // );

    // autocomplete.addListener("place_changed", () => {
    //   this.lat = null;
    //   this.lng = null;

    //   let place = autocomplete.getPlace();

    //   // get postcode
    //   this.postcode = this.extractPostcode(place.address_components);

    //   // set lat and long
    //   this.lat = place.geometry.location.lat();
    //   this.lng = place.geometry.location.lng();
    //   this.getData();
    // });
  },
  computed: {
    isMetricSystem() {
      return this.imperial_system !== "1" ? true : false;
    },
    kmOrMiSymbol() {
      return this.isMetricSystem ? "km" : "mi";
    },
    url() {
      if (this.sessionStorageSet === true) {
        return `${this.baseUrl}${this.lat}/${this.lng}/${this.radius}/${this.limit}/true`;
      }
      return `${this.baseUrl}${this.lat}/${this.lng}/${this.radius}/${this.limit}`;
    },
    filteredStores() {
      let stores = this.stores;

      // If no filters, return all stores
      if (this.serviceFilters.length == 0 && this.stockFilters.length == 0) {
        return stores;
      }

      let filtered = [];
      stores.forEach(store => {
        // check service filters
        if (store.store_service_ids != null && this.serviceFilters.length > 0) {
          let serviceIds = store.store_service_ids
            .split(",")
            .map(id => parseInt(id));

          this.serviceFilters.forEach(serviceId => {
            if (serviceIds.includes(serviceId)) {
              filtered.push(store);
            }
          });
        }

        // check stock filters
        if (store.store_stock_ids != null && this.stockFilters.length > 0) {
          let stockIds = store.store_stock_ids
            .split(",")
            .map(id => parseInt(id));

          this.stockFilters.forEach(stockId => {
            if (stockIds.includes(stockId)) {
              filtered.push(store);
            }
          });
        }
      });

      return [...new Set(filtered)];
    }
  },
  methods: {
    async getLocationData(postcode , countryCode){
      var geocoder = new google.maps.Geocoder();
      return new Promise((resolve,reject)=>{
        geocoder.geocode({ componentRestrictions: { 'country': countryCode, 'postalCode': postcode }}, (results, status)=> {
          if(results === null || results.legnth === 0){
            reject("postcode not found");
            return;
          }
          
            resolve(results[0]);
        });
      });
    },
    async getData() {
      let response = await axios.get(this.url);
      this.stores = response.data.data.stores;
      this.stockTypes = response.data.data.stock_types;
    },
    extractPostcode(address) {
      let postcode;
      address.forEach(part => {
        if (part.types[0] == "postal_code") {
          postcode = part.long_name;
        }
      });

      return postcode;
    },
     selectedData (store) {
     },
    kmOrMiNumber(n) {
      return this.isMetricSystem ? n : Math.round(n * 1.6);
    },
    mouseUp(e) {
      if (this.isOpen) {
        this.$nextTick().then(() => {
          if (!this.changed){
            // this.handler(e);
          }
        });
        this.isOpen = false;
      } else {
        this.changed = false;
        this.isOpen = true;
      }
    },
    selectedStore(e) {
      this.changed = true;
      let store_details = this.filteredStores.filter(function(item)  {
        return item.title === `${e.target.value}`;
      });
      if((typeof store_details[0].phone !== "undefined") && store_details[0].phone !== null){
          var phone = store_details[0].phone;
      }else{
        var phone = '';
      }
      if(typeof store_details[0] !== "undefined"){
        var store_full_address = store_details[0].address + ',' + store_details[0].suburb + ',' + store_details[0].state + ',' + store_details[0].postcode
        
        
        this.$emit("searchDealer", {
            data: {
              form_field_id: this.form_field_id,
              name: store_details[0].title,
              address: store_full_address,
              postcode: store_details[0].postcode,
              number: phone,
            }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
    .invisible {
        visibility: hidden;
    }
</style>